/**
 * Error state for list pages. Render this when a list query fails — a failed
 * query must be visually distinct from "zero results", otherwise transport
 * errors read as an empty search ("No X found") and get ignored.
 */
export function ListErrorState({ testId }: { testId: string }) {
  return (
    <div
      className="tw:mt-4 tw:rounded-lg tw:border tw:border-red-200 tw:bg-red-50 tw:px-4 tw:py-3 tw:text-red-700"
      data-testid={testId}
    >
      <p className="tw:font-semibold">Something went wrong</p>
      <p className="tw:text-sm">
        Please try again later. If the problem persists, please contact us.
      </p>
    </div>
  );
}
